export const BASE_RULE = <const>{
	elementType: 1,
	elementSubType1: 4,
	elementSubType2: 0,
	elementValue1: '',
	elementValue2: '',
	elementValue3: '',
};

export default BASE_RULE;
